<template src="./PartnerClientUpload.html"></template>

<script>
import mixins from "../../../../../Mixins.js"; 
export default {
  mixins: [mixins],
  data() {
    return {
      documentData: "",
      clients: [],
      files: [],
      currentx: 1,
      code: 0,
      numPages: 0,
      windowWidth: 0,
      pagination: false,
    };
  },
  watch: { 
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  mounted() {
    const vm = this;
    vm.bearerDefault = vm.$session.get("bearerDefault");
    vm.$session.set("bearerDefault", vm.bearerDefault);
    if (vm.$route.params) {
        vm.code = vm.$route.params.id;
    }
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    addFile(e) {
      var vm = this;
      const droppedFiles = e.dataTransfer.files;
      let doUpload = false;
      var extAllowed = ["xlsx"];
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        if (f.size > 90000000) {
          vm.$vs.notify({
            title: "Atenção!",
            text:
              "O arquivo \"" +
              f.name +
              "\" ultrapassou o tamanho permitido de 90MB!",
            color: "warning",
            icon: "error",
            position: "top-right",
          });

          return (doUpload = false);
        }
        var extFile = f.name.split(".").pop();
        if (
          typeof extAllowed.find(function(ext) {
            return extFile == ext;
          }) == "undefined"
        ) {
          vm.$vs.notify({
            title: "Atenção!",
            text:
              "O arquivo " +
              f.name +
              " possui extensão \"" +
              extFile +
              "\" não permitida!",
            color: "warning",
            icon: "error",
            position: "top-right",
          });

          return (doUpload = false);
        } else {
          doUpload = true;
          vm.files.push(f);
        }
      });

      if (droppedFiles.length > 0 && doUpload === true) {
        for (var i = 0; i < droppedFiles.length; i++) {
          const file = droppedFiles[i];

          const formData = new FormData();

          formData.append("file", file);

          vm.axios
            .post(
              vm.$store.state.filooServer + `company/upload/plan/${vm.code}`,
              formData,
              {
                headers: { Authorization: vm.$session.get("bearer") },
                "Content-Type": "multipart/form-data",
              }
            )
            .then(function(response) {
              if (response.status === 200) {
                vm.$swal({
                  title: "Importação realizada com sucesso!",
                  text:
                    "O arquivo está sendo processado e estará disponível para download em alguns instantes.",
                  icon: "success",
                }).then(function() {
                });
              }
            })
            .catch(function(error) {
              console.log({ error: error });
              vm.$swal({
                title: "Atenção!",
                text:
                  "Não foi possível realizar esta operação contacte o administrador do sistema.",
                icon: "error",
              });
            });
        }
      }
    },
    
    clickAddFile: function(e) {
      var vm = this;
      var input = e.target;

      var extAllowed = ["xlsx"];

      var extFile = input.value.split(".").pop();

      if (input.files[0].size > 90000000) {
        vm.$vs.notify({
          title: "Atenção!",
          text:
            "O arquivo \"" +
            input.files[0].name +
            "\" ultrapassou o tamanho permitido de 90MB!",
          color: "warning",
          icon: "error",
          position: "top-right",
        });
      }
      if (
        typeof extAllowed.find(function(ext) {
          return extFile == ext;
        }) == "undefined"
      ) {
        vm.$vs.notify({
          title: "Atenção!",
          text: "Extensão \"" + extFile + "\" não permitida!",
          color: "warning",
          icon: "error",
          position: "top-right",
        });
      } else {
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
          // create a new FileReader to read this image and convert to base64 format
          var reader = new FileReader();
          // Define a callback function to run, when FileReader finishes its job
          reader.onload = e => {
            // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
            // Read image as base64 and set to imageData
            vm.documentData = e.target.result;
          };
          // Start the reader job - read file as a data url (base64 format)
          reader.readAsDataURL(input.files[0]);

          const formData = new FormData();
          formData.append("file", input.files[0], input.files[0].name);

          vm.axios
            .post(
              vm.$store.state.filooServer + "company/users/upload",
              formData,
              {
                headers: { Authorization: vm.$session.get("bearer") },
                "Content-Type": "multipart/form-data",
              }
            )
            .then(function(response) {
              if (response.status === 200) {
                vm.$swal({
                  title: "Importação iniciada!",
                  text:
                    "O arquivo está sendo processado e estará disponível para download em alguns instantes.",
                  icon: "success",
                }).then(function() {
                });
              }
            })
            .catch(function(error) {
              console.log({ error: error });
              vm.$swal({
                title: "Atenção!",
                text:
                  "Não foi possível realizar esta operação contacte o administrador do sistema.",
                icon: "error",
              });
            });
        }
      }
    },
    downloadFile(id, fileName) {
      var vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "company/upload-registers/" +
            id +
            "/download/" +
            fileName +
            ".xlsx",
          {
            headers: { Authorization: vm.$session.get("bearer") },
            responseType: "arraybuffer",
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "template.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function(error) {
          console.log({ error: error });
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    downloadTemplate() {
      var vm = this;

      vm.axios
        .get(vm.$store.state.filooServer + "company/excel/template.xlsx", {
          headers: { Authorization: vm.$session.get("bearer") },
          responseType: "arraybuffer",
        })
        .then(function(response) {
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "template.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function(error) {
          console.log({ error: error });
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
  
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

